__turbopack_context__.v({
  "active": "XwEV4q_active",
  "buttonsWrapper": "XwEV4q_buttonsWrapper",
  "close": "XwEV4q_close",
  "collapsedSubmenu": "XwEV4q_collapsedSubmenu",
  "container": "XwEV4q_container",
  "expandBtn": "XwEV4q_expandBtn",
  "expandedSubmenu": "XwEV4q_expandedSubmenu",
  "hide": "XwEV4q_hide",
  "icon": "XwEV4q_icon",
  "logoWrapper": "XwEV4q_logoWrapper",
  "logoWrapperImage": "XwEV4q_logoWrapperImage",
  "navbar": "XwEV4q_navbar",
  "navbarExpanded": "XwEV4q_navbarExpanded",
  "slideIn": "XwEV4q_slideIn",
  "slideUp": "XwEV4q_slideUp",
  "submenu": "XwEV4q_submenu",
});
